import React from 'react';
import SessionReplay from '../components/SessionReplay';
import { statelessDemoTrace } from '../shared/statelessDemoTrace';

// Clean, chrome-free page for screen-recording the Twitter/X clip.
// Route: /stateless/demo
const DemoCapture: React.FC = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#ffffff',
        padding: 24,
      }}
    >
      <div style={{ width: 720, maxWidth: '100%' }}>
        <SessionReplay trace={statelessDemoTrace} />
      </div>
    </div>
  );
};

export default DemoCapture;
